// 🔧 schedule_step.js
// ✅ Purpose: Schedule Builder pipeline step
// ✅ Features:
// - Executes Schedule Builder
// - Creates standardized pipeline results
// - Updates DemoContext with created schedule items
// - Keeps schedule generation modular
// - Fully block-commented for clarity and future devs

import {
  createPipelineStepSuccess,
} from "../pipeline_step";

import {
  buildScheduleShell,
} from "../../builders/schedule_builder";

export const createScheduleStep = () => ({
  name: "schedule_builder",

  label: "Schedule Builder",

  run: async (context) => {
    const result =
      await buildScheduleShell(
        context
      );

    return createPipelineStepSuccess({
      step:
        "schedule_builder",

      label:
        "Schedule Builder",

      created:
        result?.createdCount || 0,

      message:
        result?.message,

      metadata:
        result,

      startedAt:
        context.startedAt,
    });
  },

  afterSuccess: ({
    result,
    sharedContext,
  }) => {
    sharedContext.scheduleResult =
      result?.metadata || null;

    sharedContext.scheduleItems =
      result?.metadata?.createdScheduleItems || [];
  },
});